import React from 'react'

const OnNotesContext = React.createContext(null)

const OnNotesProvider = ({ children }) => {
  const [onNotes, setOnNotes] = React.useState({})

  const showNotes = React.useCallback(id => {
    setOnNotes(old => ({ ...old, [id]: true }))
  }, [])

  const hideNotes = React.useCallback(id => {
    setOnNotes(old => ({ ...old, [id]: false }))
  }, [])

  return (
    <OnNotesContext.Provider value={{ onNotes, showNotes, hideNotes }}>
      {children}
    </OnNotesContext.Provider>
  )
}

export default OnNotesProvider

export const useOnNotes = () => React.useContext(OnNotesContext)
